import { useData } from "../context/DataContext";

export const useConfig = () => {
  const { data } = useData();
  return data.config;
};

export const useSoftware = () => {
  const { data } = useData();
  return data.software;
};

export const useCompany = () => {
  const { data } = useData();
  return data.company;
};

export const useStatistics = () => {
  const { data } = useData();
  return data.statistics;
};

export const useContent = () => {
  const { data } = useData();
  return data.content;
};

export const useWebsiteConfig = () => {
  const config = useConfig();
  return config.website;
};

export const useContactInfo = () => {
  const config = useConfig();
  return config.contact;
};

export const useSocialLinks = () => {
  const config = useConfig();
  return config.social;
};

export const usePricing = () => {
  const { data } = useData();
  return data.pricing;
};

export const useTestimonials = () => {
  const { data } = useData();
  return data.testimonials;
};

export const useLocations = () => {
  const { data } = useData();
  return data.locations;
};
